import React, { useState, useEffect, useRef, Fragment } from "react";
import {Link} from "react-router-dom"
import shop from "shop/shop"
import ImageWithFallback from "components/ImageWithFallback"

const AUTOPLAY_INTERVAL = 4000;

const CategorySliderV2 = ({ categoryforCards1, translate }) => {
  //console.log("CategorySliderV2 render", categoryforCards1);
  if (!categoryforCards1 || !categoryforCards1.children) return null;
  if(categoryforCards1.children[0] && !categoryforCards1.children[0].map_id) {
    //console.warn("CategorySliderV2: No valid categories provided", categoryforCards1.children);
    return null;
  }
  const items = categoryforCards1.children;
  const totalItems = items.length;

  const getVisibleItems = () => {
    if (window.innerWidth <= 700) return 1;
    if (window.innerWidth <= 1200) return 2;
    return 3;
  };

  const [visibleItems, setVisibleItems] = useState(getVisibleItems);
  const [page, setPage] = useState(1); // wegen Clone
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const startX = useRef(0);
  const currentX = useRef(0);
  const autoplayRef = useRef(null);

  useEffect(() => {
    const onResize = () => {
      setVisibleItems(getVisibleItems());
      setPage(1);
    };

    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const totalPages =
    Math.ceil(totalItems / visibleItems) + 2; // +2 Clones

  useEffect(() => {
    console.log("Page changed:", page, totalPages);
    if (page === 0) {
      setTimeout(() => setPage(totalPages - 2), 0);
    }
    if (page === totalPages - 1) {
      setTimeout(() => setPage(1), 0);
    }
  }, [page, totalPages]);

  useEffect(() => {
    console.log("Autoplay effect:", isHovered, isDragging, visibleItems);
    if (isHovered || isDragging || visibleItems === 1 || totalItems <= visibleItems) return;

    autoplayRef.current = setInterval(() => {
      setPage((p) => p + 1);
    }, AUTOPLAY_INTERVAL);

    return () => clearInterval(autoplayRef.current);
  }, [isHovered, isDragging, visibleItems, totalItems]);

  const handleStart = (x) => {
    startX.current = x;
    currentX.current = x;
    setIsDragging(true);
  };

  const handleMove = (x) => {
    if (!isDragging) return;
    currentX.current = x;
    setDragOffset(x - startX.current);
  };

  const handleEnd = () => {
    if (!isDragging) return;

    const delta = currentX.current - startX.current;
    const threshold = 60;

    if (delta > threshold) setPage((p) => p - 1);
    else if (delta < -threshold) setPage((p) => p + 1);

    setDragOffset(0);
    setIsDragging(false);
  };

  const lastPage = totalPages - 1;
  const translateX =
    -page * 100 +
    (dragOffset / window.innerWidth) * (100 / visibleItems);


  const slides = [
    ...items.slice(-visibleItems),
    ...items,
    ...items.slice(0, visibleItems),
  ];

  const showDots = visibleItems > 1;

  return (
    
    <div
      className="sectionCategoryV2 with-dots"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className="category-track"
        style={{
          transform: `translateX(${translateX}%)`,
          transition: isDragging ? "none" : "transform 0.45s ease",
        }}
        onMouseDown={(e) => handleStart(e.clientX)}
        onMouseMove={(e) => handleMove(e.clientX)}
        onMouseUp={handleEnd}
        onMouseLeave={handleEnd}
        onTouchStart={(e) => handleStart(e.touches[0].clientX)}
        onTouchMove={(e) => handleMove(e.touches[0].clientX)}
        onTouchEnd={handleEnd}
      >
        {slides.map((cat, idx) => (<Fragment key={`${cat.map_id || idx}-${idx}`}>
          <Link to={`/collection/${cat.map_id || idx}`}  className="category-card">
          <div as={Link} to ={`/collection/${cat.map_id || idx}`}
            key={`${cat.map_id || idx}-${idx}`}
            className=""
            style={{ flex: `0 0 ${100 / visibleItems}%` }}
          >
          <ImageWithFallback 
                          fallback={"/image/placeholder.png"}
                          title={`${cat.title}`}
                          src={cat.img_src_medium}
                          alt={cat.title || ""} className="category-image" />
            <p className="cssOptima f3 fw7 pt2 pb2 black transition cssLindtGold">{cat.title}</p>
            <Link className={` db pl3 pr3 pb4 f5 fw5 b hover-primary black-30 transition`} to={`/collection/${cat.map_id || idx}`} >
              {translate("Produkte ansehen")}
            </Link>
          </div>
          </Link>
          </Fragment>
        ))}
      </div>
      

      {totalItems > visibleItems && (
        <div className="dots">
          {Array.from({
            length: Math.ceil(totalItems / visibleItems),
          }).map((_, i) => (
            <button
              key={i}
              className={page - 1 === i ? "active" : ""}
              onClick={() => setPage( page == 3 ? i + 1/3 : i + 1)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CategorySliderV2;


// WEBPACK FOOTER //
// ./src/plugin/CategoryShortcuts/CategorySliderV2.js